import { render, staticRenderFns } from "./preorder.vue?vue&type=template&id=3c8523a2&"
import script from "./preorder.js?vue&type=script&lang=js&"
export * from "./preorder.js?vue&type=script&lang=js&"
import style0 from "./preorder.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c8523a2')) {
      api.createRecord('3c8523a2', component.options)
    } else {
      api.reload('3c8523a2', component.options)
    }
    module.hot.accept("./preorder.vue?vue&type=template&id=3c8523a2&", function () {
      api.rerender('3c8523a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/preorder/preorder.vue"
export default component.exports